// extracted by mini-css-extract-plugin
export var chip = "_e1-0";
export var filterDropdown = "_e1-5";
export var filterItem = "_e1-6";
export var icon = "_e1-1";
export var removeButton = "_e1-3";
export var removeIcon = "_e1-4";
export var separator = "_e1-2";